import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent, { timelineContentClasses } from '@mui/lab/TimelineContent';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Avatar, Button, Paper, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { useStoreState } from 'pullstate';
import * as React from 'react';
import { useCallback, useState } from 'react';
import { AppStore } from '../stores/AppStore.js';
import RichtextFormatter from './RichtextFormatter.jsx';
import SlateRenderer from './SlateRenderer.jsx';

export default function CommentsTimeline(props) {
    const { setComment, comment, comments, setComments, handleCommentsChange, goalSelectedToComment, label, setCheckinData } = props
    const [textfieldHelpText, setTextfieldHelpText] = useState('')
    const [errorTextfield, setErrorTextfield] = useState(false)
    const [loggedUser] = useState(useStoreState(AppStore, s => s.user))

    const handleAddComment = useCallback(() => {
        const commentToSave = JSON.stringify(comment)

        const addComments = [...comments ?? [], {
            comment: commentToSave,
            commentDate: moment(),
            name: loggedUser.full_name,
            avatar: loggedUser.photo_url
        }]
        setComments(addComments)
        handleCommentsChange ? handleCommentsChange(goalSelectedToComment?.id, addComments) : ''

        setComment([{
            type: 'paragraph',
            children: [{ text: '' }],
        }])
    })

    const hasTextContent = (node) => {
        if (node.text !== undefined) {
            return node.text.trim() !== '';
        }

        if (node.children && Array.isArray(node.children)) {
            return node.children.some(child => hasTextContent(child));
        }

        return false;
    };

    const handleClickAddComment = () => {
        const hasContent = comment &&
            Array.isArray(comment) &&
            comment.some(node => hasTextContent(node));

        if (!hasContent) {
            setTextfieldHelpText(`Comment should not be empty`)
            setErrorTextfield(true)
            return
        }

        handleAddComment()
    }

    React.useEffect(() => {
        setCheckinData ? setCheckinData(prevState => ({ ...prevState, general_comments: JSON.stringify(comments) })) : ''
    }, [comments])

    return (
        <>
            <Timeline
                style={{ marginLeft: '0px', marginRight: '0px', padding: '0px' }}
                position='left'
                sx={{
                    [`& .${timelineContentClasses.root}`]: {
                        flex: 0.2,
                    },
                }}
            >
                {comments?.map((item, index) => (
                    <TimelineItem key={index} sx={{ width: '100%' }} >
                        <TimelineOppositeContent
                            sx={{
                                m: 'auto 0',
                                overflowWrap: 'anywhere',
                                whiteSpace: 'pre-wrap'
                            }}
                            align="left"
                            variant="body2"
                            color="text.secondary"
                        >
                            <SlateRenderer content={item.comment} />
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineConnector />
                            <Avatar src={item.avatar} />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <Stack sx={{ width: '20%', justifyContent: 'center' }}>
                            <TimelineContent style={{ paddingLeft: 0 }} sx={{ py: '12px', px: 2, textAlign: 'center' }}>
                                <Typography>{item.name}</Typography>
                                <Typography style={{ paddingLeft: 0 }} sx={{ fontSize: '11px' }} color={'text.secondary'} >{moment(item.commentDate).format('MMM DD, YYYY [at] h:mm a')}</Typography>
                            </TimelineContent>
                        </Stack>
                    </TimelineItem>
                ))}
            </Timeline >
            <Stack direction="column" spacing={2}>
                {/* <Paper sx={{ padding: 2, width: '100%' }}> */}
                    <RichtextFormatter
                        label={label}
                        initialValue={comment}
                        setTextfieldHelpText={setTextfieldHelpText}
                        setErrorTextfield={setErrorTextfield}
                        setComment={setComment}
                        helperText={textfieldHelpText}
                        error={errorTextfield}
                    />
                {/* </Paper> */}
                <Button
                    variant='outlined'
                    sx={{ width: '20%', alignSelf: 'flex-end', marginTop: 1 }}
                    onClick={handleClickAddComment}
                >
                    Add Comment
                </Button>

            </Stack>
        </>
    );
}
